import { Messages } from 'constants/rpcTypes';
import { usePermission } from 'hooks';
import { FC } from 'react';
import HelpDesk from 'components/helpDesk';

export const HelpDeskWrapper: FC = () => {
  const { isEnabled } = usePermission();

  const isHelpdeskAvailable =
    isEnabled(Messages.SupportChat_Messages) ||
    isEnabled(Messages.HelpTips_List);

  return isHelpdeskAvailable && <HelpDesk />;
};
